var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery, useMutation } from '@apollo/client';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DateTimePicker } from '@mui/lab';
import { Alert, Button, Collapse, DialogActions, IconButton, TextField } from '@mui/material';
import { getCurrentTimeZone } from 'common/const/timezones';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { Sports } from 'common/enums/sport/sports.enum';
import { CREATE_ACTIVITY } from 'common/graphql/mutations/activity/createActivity/create-activity';
import { CREATE_ACTIVITY_ATTACHMENT } from 'common/graphql/mutations/activityAttachment/create-activity-attachment';
import { ACTIVITY_ATTACHMENTS } from 'common/graphql/queries/activity/activity-attachments';
import { CHECK_ACTIVITY_DUPLICATES } from 'common/graphql/queries/activity/checkActivityDuplicates';
import { REQUEST_NEW_ACTIVITY_VALIDATION_INFO } from 'common/graphql/queries/activity/request-new-activity-validation-info';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import createActivityValidationSchema from 'common/validationSchemas/createActivityValidationSchema';
import LoadingFilesForm from 'components/Forms/LoadingFilesForm';
import SportSelect from 'components/Select/SportSelect';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { openSnackbar } from 'store/actions';
import CreateActivityManualActivityValidationInputs from './CreateActivityManualActivityValidationInputs';
import CreateActivityManualAttachments from './CreateActivityManualAttachments';
import CreateActivityManualDurationNumberInput from './CreateActivityManualDurationNumberInput';
var CreateActivityManualForm = function (_a) {
    var _b, _c;
    var userId = _a.userId, handleClose = _a.handleClose;
    var _d = useState(false), isAdditionalInfoInputsOpen = _d[0], setIsAdditionalInfoInputsOpen = _d[1];
    var defaultFormState = {
        name: '',
        description: '',
        distance: null,
        startDate: null,
        elapsedTime: null,
        sport: Sports.Run,
        averageCadence: null,
        maxSpeed: null,
        avgHeartRate: null,
        elevation: null,
        timezoneOffSet: getCurrentTimeZone().offsetSeconds
    };
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _e = useState(undefined), loadingFiles = _e[0], setLoadingFiles = _e[1];
    var _f = useState(), validationInfo = _f[0], setValidationInfo = _f[1];
    var _g = useLazyQuery(REQUEST_NEW_ACTIVITY_VALIDATION_INFO), getNewActivityValidationInfo = _g[0], newActivityValidationInfoData = _g[1].data;
    var _h = useLazyQuery(CHECK_ACTIVITY_DUPLICATES), getDuplicatesActivity = _h[0], duplicatesActivity = _h[1].data;
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t('Тренировка создана и отправлена на проверку администратору'),
            severity: SnackbarSeverity.SUCCESS
        }));
        if (!(loadingFiles === null || loadingFiles === void 0 ? void 0 : loadingFiles.length))
            handleClose();
    };
    var onError = function (_a) {
        var errorDetails = _a.errorDetails, message = _a.message, code = _a.code;
        dispatch(openSnackbar({
            message: errorDetails || message || code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var createActivity = function (data) {
        return useMutation(CREATE_ACTIVITY, {
            variables: {
                createActivityData: __assign({ userId: userId }, data)
            }
        });
    };
    var _j = useDynamicMutation(createActivity, onSuccess, onError), handleExecuteMutation = _j.handleExecuteMutation, createdActivityData = _j.data;
    var handleSubmit = function (data) {
        var convertedData = __assign({}, data);
        if (convertedData.distance)
            convertedData.distance = parseInt(convertedData.distance);
        if (convertedData.elapsedTime)
            convertedData.elapsedTime = parseInt(convertedData.elapsedTime);
        if (convertedData.averageCadence) {
            convertedData.averageCadence = parseInt(convertedData.averageCadence);
        }
        else {
            convertedData.averageCadence = undefined;
        }
        if (convertedData.maxSpeed) {
            convertedData.maxSpeed = parseInt(convertedData.maxSpeed);
        }
        else {
            convertedData.maxSpeed = undefined;
        }
        if (convertedData.avgHeartRate) {
            convertedData.avgHeartRate = parseInt(convertedData.avgHeartRate);
        }
        else {
            convertedData.avgHeartRate = undefined;
        }
        if (convertedData.elevation) {
            convertedData.elevation = parseInt(convertedData.elevation);
        }
        else {
            convertedData.elevation = undefined;
        }
        // console.log(convertedData);
        handleExecuteMutation(__assign(__assign({}, convertedData), { validationInfo: validationInfo }));
    };
    var uploadFile = function (file) {
        var _a, _b;
        return useMutation(CREATE_ACTIVITY_ATTACHMENT, {
            variables: {
                createActivityAttachmentData: {
                    activityId: (_a = createdActivityData === null || createdActivityData === void 0 ? void 0 : createdActivityData.createActivity) === null || _a === void 0 ? void 0 : _a.id
                },
                file: file
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: ACTIVITY_ATTACHMENTS,
                    variables: {
                        id: (_b = createdActivityData === null || createdActivityData === void 0 ? void 0 : createdActivityData.createActivity) === null || _b === void 0 ? void 0 : _b.id
                    }
                },
            ]
        });
    };
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined);
        formik.handleChange(e);
    };
    var formik = useFormik({
        initialValues: __assign({}, defaultFormState),
        validationSchema: createActivityValidationSchema.pick(Object.keys(defaultFormState)),
        onReset: handleClose,
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    useEffect(function () {
        var _a = formik.values, sport = _a.sport, startDate = _a.startDate, elapsedTime = _a.elapsedTime;
        if (sport && startDate) {
            getNewActivityValidationInfo({
                variables: {
                    sportName: sport,
                    activityStartDate: startDate
                }
            });
        }
        if (startDate && elapsedTime) {
            getDuplicatesActivity({
                variables: {
                    startDate: startDate,
                    elapsedTimeSeconds: parseInt(elapsedTime)
                }
            });
        }
    }, [formik.values]);
    return !((_b = createdActivityData === null || createdActivityData === void 0 ? void 0 : createdActivityData.createActivity) === null || _b === void 0 ? void 0 : _b.id) ? (_jsxs("form", __assign({ onSubmit: formik.handleSubmit, onReset: formik.handleReset, className: "sm:min-w-320" }, { children: [_jsx("div", __assign({ className: "flex flex-col p-0 pb-20" }, { children: _jsxs("div", __assign({ className: "flex flex-col space-y-20" }, { children: [_jsx(TextField, { required: true, label: t('Название'), name: "name", value: formik.values['name'], onChange: handleChangeWrapper, error: Boolean(t(formik.errors['name'] || '')), helperText: t(formik.errors['name'] || '') }, void 0), _jsx(TextField, { label: t('Описание'), name: "description", value: formik.values['description'], onChange: handleChangeWrapper, error: Boolean(t(formik.errors['description'] || '')), helperText: t(formik.errors['description'] || '') }, void 0), _jsxs("div", __assign({ className: "flex flex-col w-full space-y-20" }, { children: [_jsx(Alert, __assign({ severity: "info" }, { children: t('createActivityManualFormDatePickerAlert') }), void 0), _jsx(DateTimePicker, { mask: "__/__/____ __:__", inputFormat: "dd/MM/yyyy HH:mm", label: t('Дата и время начала'), value: formik.values['startDate'] && new Date(formik.values['startDate']), maxDate: new Date(), onChange: function (date) {
                                        formik.setFieldError('startDate', undefined);
                                        formik.setFieldValue('startDate', date);
                                    }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { error: Boolean(formik.errors['startDate']), helperText: t(formik.errors['startDate'] || '') }), void 0)); } }, void 0)] }), void 0), _jsx(SportSelect, { value: formik.values['sport'], handleChange: formik.setFieldValue, disableClearable: false, errorMessage: t(formik.errors['sport'] || ''), name: "sport" }, void 0), _jsx(TextField, { required: true, label: t('Дистанция, м'), name: "distance", value: formik.values['distance'], onChange: handleChangeWrapper, error: Boolean(formik.errors['distance']), helperText: t(formik.errors['distance'] || '') }, void 0), _jsx(CreateActivityManualDurationNumberInput, { handleChange: formik.setFieldValue, onChange: function () { return formik.setFieldError('elapsedTime', undefined); }, isError: Boolean(formik.errors['elapsedTime']), errorText: t(formik.errors['elapsedTime'] || '') }, void 0), duplicatesActivity && duplicatesActivity.checkActivityDuplicates && (_jsxs("p", __assign({ className: "text-12" }, { children: [_jsxs("span", __assign({ className: "text-red " }, { children: [t('createActivityDuplicate'), "."] }), void 0), ' ', _jsxs(Link, __assign({ to: "/activity/".concat(duplicatesActivity.checkActivityDuplicates.id), className: "text-mainYellow hover:underline cursor-pointer" }, { children: [duplicatesActivity.checkActivityDuplicates.name, ' ', new Date(duplicatesActivity.checkActivityDuplicates.startDate).toLocaleDateString(), "."] }), void 0), ' ', _jsx("span", __assign({ className: "text-red" }, { children: t('createActivityDuplicate2') }), void 0)] }), void 0)), _jsxs("div", __assign({ className: "pl-8 space-x-20 flex items-center cursor-pointer hover:underline max-w-240", onClick: function () { return setIsAdditionalInfoInputsOpen(!isAdditionalInfoInputsOpen); } }, { children: [_jsx("div", __assign({ className: "text-mainYellow hover:underline" }, { children: t('Дополнительная информация') }), void 0), _jsx(IconButton, __assign({ className: "h-16 w-16", "aria-label": "expand", size: "small" }, { children: isAdditionalInfoInputsOpen ? _jsx(ExpandLessIcon, {}, void 0) : _jsx(ExpandMoreIcon, {}, void 0) }), void 0)] }), void 0), _jsx(Collapse, __assign({ "in": isAdditionalInfoInputsOpen }, { children: _jsxs("div", __assign({ className: "flex flex-wrap gap-10" }, { children: [_jsx(TextField, { label: t('Средний каденс'), name: "averageCadence", value: formik.values['averageCadence'], onChange: handleChangeWrapper, error: Boolean(formik.errors['averageCadence']), helperText: t(formik.errors['averageCadence'] || '') }, void 0), _jsx(TextField, { label: t('Максимальная скорость, м/с'), name: "maxSpeed", value: formik.values['maxSpeed'], onChange: handleChangeWrapper, error: Boolean(formik.errors['maxSpeed']), helperText: t(formik.errors['maxSpeed'] || '') }, void 0), _jsx(TextField, { label: t('Средняя ЧСС'), name: "avgHeartRate", value: formik.values['avgHeartRate'], onChange: handleChangeWrapper, error: Boolean(formik.errors['avgHeartRate']), helperText: t(formik.errors['avgHeartRate'] || '') }, void 0), _jsx(TextField, { label: t('Набор высоты, м'), name: "elevation", value: formik.values['elevation'], onChange: handleChangeWrapper, error: Boolean(formik.errors['elevation']), helperText: t(formik.errors['elevation'] || '') }, void 0)] }), void 0) }), void 0), _jsx(CreateActivityManualActivityValidationInputs, { requestNewActivityValidationInfo: newActivityValidationInfoData === null || newActivityValidationInfoData === void 0 ? void 0 : newActivityValidationInfoData.requestNewActivityValidationInfo, setValidationInfo: setValidationInfo }, void 0), _jsx(CreateActivityManualAttachments, { loadingFiles: loadingFiles, setLoadingFiles: setLoadingFiles }, void 0)] }), void 0) }), void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", type: "reset", onClick: handleClose }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)] }), void 0)) : createdActivityData && ((_c = createdActivityData.createActivity) === null || _c === void 0 ? void 0 : _c.id) && loadingFiles && (loadingFiles === null || loadingFiles === void 0 ? void 0 : loadingFiles.length) > 0 ? (_jsx(LoadingFilesForm, { formText: t('Загрузка файлов'), loadingFiles: loadingFiles, executableMutation: uploadFile }, void 0)) : null;
};
export default CreateActivityManualForm;
